<div class="menu-crud-panel-bot">
	<div class="panel-bot-buttons">
		<div class="buttons-block buttons-block-l"></div>
		<div class="buttons-block-blank"></div>
		<div class="buttons-block buttons-block-r"></div>
	</div>
	<div class="panel-bot-content">
		<ng-content select="[PanelContent]"></ng-content>
	</div>
	<div class="panel-bot-rows">
		@for (
				row of rows(); track row.uuid) {
			<app-table-row-wrapper detailed [id]="row.uuid" hideIcon [row]="row"></app-table-row-wrapper>
		}
	</div>
	<div class="panel-bot-buttons">
		@for (
				btn of btns(); track btn.uuid) {
			<div class="btn-block" (click)="btn.func()">
				<div class="btn-icon">
					<i class="fal fa-sharp" [ngClass]="'fa-'+btn.icon"></i>
				</div>
				@if (btn.text) {
					<div class="btn-text">{{btn.text}}</div>
				}
			</div>
		}
	</div>
</div>